import ajax from "../assets/uilt/ajax";

let expense = {
  // get list of expense type by name
  getAllExpenseType: (req) => {
    return ajax.get({
      url: "/back/expense/get-expense-type",
      param: req.param,
      success: req.success,
      failing: req.failing,
    });
  },

  //add expense
  addExpense: (req) => {
    return ajax.post({
      url: "/back/expense/add-expense",
      param: req.param,
      success: req.success,
    });
  },

  getExpensePage: (req) => {
    return ajax.get({
      url: "/back/expense/get-expense-page",
      param: req.param,
      success: req.success,
    });
  },

  updateExpenseStatus: (req) => {
    return ajax.post({
      url: "/back/expense/update-expense-status",
      param: req.param,
      success: req.success,
    });
  },

  reverseExpense: (req) => {
    return ajax.post({
      url: "/back/expense/reverse-expense",
      param: req.param,
      success: req.success,
    });
  },

  getExpenseSummary(obj) {
    ajax.get({
      url: "/back/expense/get-expense-summary",
      param: obj.param,
      success: obj.success,
      failing: obj.failing,
    });
  },
};

export default expense;
